import { useTranslation } from "react-i18next";
import HeroSlider from "../../components/HeroSlider/HeroSlider";
import InstagramFeed from "../../components/InstagramFeed/InstagramFeed";
import TrainingSchedule from "../../components/TrainingSchedule/TrainingSchedule";
import img8 from "../../assets/HeroSlider/hero8.jpg";
import img5 from "../../assets/HeroSlider/hero5.jpg";
import img1 from "../../assets/HeroSlider/hero3.jpg";
import styles from "./About.module.scss";

const images = [img5, img8, img1];

const About = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.about}>
      <HeroSlider label={t("hero_slider_about")} images={images} />

      <div className={styles.container}>
        <article className={styles.introCard}>
          <div className={styles.introCopy}>
            <span className={styles.eyebrow}>{t("about_intro_eyebrow")}</span>
            <h1>{t("about_intro_title")}</h1>
            <p>{t("about_intro_text")}</p>

          </div>

          <div className={styles.storyCard}>
            <h2>{t("about_title")}</h2>
            <p>{t("about_description")}</p>
          </div>
        </article>

        <InstagramFeed />
        <TrainingSchedule />
      </div>
    </section>
  );
};

export default About;
